<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div
    class="flex h-full flex-col items-center justify-center px-6 text-center"
  >
    <div
      class="mb-4 flex size-24 items-center justify-center rounded-full border-2 border-lais-text"
    >
      <span class="i-lucide-send-horizontal size-12 text-lais-text" />
    </div>
    <h2 class="text-[20px] font-normal text-lais-text">
      {{ $t('CONVERSATION.EMPTY_STATE.TITLE') }}
    </h2>
    <span
      class="mt-2 max-w-[360px] text-[14px] font-normal leading-6 text-lais-text-muted"
    >
      {{ message }}
    </span>
  </div>
</template>
